export const fiscalTest = {
	testing: "Testar dados fiscais ({{count}})",
	testingMessage: "Testando {{count}} produto(s) selecionado(s)...",
	testingProgress: "{{tested}} de {{total}} testados",
	successTitle: "Testar dados fiscais ({{count}})",
	successMessage: "Todos os produtos foram testados com sucesso!",
	successMainText: "Dados fiscais testados com sucesso",
	successSubText: "Não foi encontrado nenhum erro nos dados apresentados",
	errorTitle: "Testar dados fiscais ({{count}})",
	errorMessage: "Ops... Algo não saiu como planejado.",
	errorSubMessage: "Encontramos erros nos dados fiscais apresentados",
	errorMainText: "Ops... Algo não saiu como planejado.",
	errorSubText: "Encontramos erros nos dados fiscais apresentados",
	success: "Dados fiscais testados com sucesso",
	error: "Erro ao testar dados fiscais",
	unknownError: "Erro desconhecido",
	errorTableProduct: "Produto",
	errorTableMessage: "Erro",
};
